import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/BinConsolidationReport';


const BinConsolidationReport = ({ t }) => (
  <Container>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

BinConsolidationReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(BinConsolidationReport);
